import { useLazyQuery } from "@apollo/client";
import { LIST_PROJECT_USER_CANDIDATES } from "../../graphql/queries/ProjectContext";

// eslint-disable-next-line import/prefer-default-export
export const useListProjectUserCandidates = () => {
  const [listProjectUserCandidates, { data, error, loading }] = useLazyQuery(LIST_PROJECT_USER_CANDIDATES);

  return [listProjectUserCandidates, { data, error, loading }];
};
